export default function SectionFiftyFiftySplit(el, {
    parentClass,
}) {
    const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
            el.classList.add(`${parentClass}__images--active`);
            observer.unobserve(el);
        }
    }, { threshold: 0.25 });

    observer.observe(el);
}
